import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import BootstrapVue from 'bootstrap-vue'

import router from './router.js'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import COMPANY from './constants'

Vue.use(BootstrapVue)
Vue.use(VueRouter)
Vue.config.productionTip = false

Vue.prototype.$COMPANY = COMPANY

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
